import React from "react";
import { Navigate } from "react-router";
import { useAuth } from "../../hooks/use-auth";
import { usePermission } from "../../hooks/use-permission";
import { useLocation } from "react-router-dom";

function Protect({ element, permissions }) {
  const { isAuthenticated } = useAuth();
  const { allowed, isLoading } = usePermission(permissions);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to={"/login"} />;
  }

  if (isLoading) {
    return null;
  }

  if (permissions && !allowed) {
    return <Navigate to={'/no-access'} replace state={{ from: `${location.pathname}${location.search}` }} />;
  }

  return element;
}

export default Protect;
